










































































import { Component } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import { State } from 'vuex-class';
/**
 * 触发器编辑页
 *
 * @author liyuyao
 * @date 03/28/2019
 */
@Component
export default class RgTrigger extends PaginationMixin {
    @State(state => state.cti.permission.rg_trigger)
    permission: boolean;

    triggerList: any = [];

    tableLoading: Boolean = true;
    $mtd: any;

    triggerId: number = 0;
    hoverContent: string = '';
    createDisplayNames: any = {};

    mounted() {
        this.currentPage = +this.$route.query.cn || 1;
        this.getTriggerList();
    }
    async getTriggerList() {
        this.tableLoading = true;
        try {
            const res = await api.ruleApi.getTriggerList({
                cn: this.currentPage,
                sn: this.limit,
                scene: 'RG',
                sceneId: this.rgId
            });
            const { code, data } = res;
            if (code === 200) {
                this.triggerList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getTriggerList();
                }
                this.triggerList = data.items;
                const createUserList = this.triggerList.map(trigger => {
                    return trigger.createdBy;
                });
                this.searchDisplayNameList(createUserList);
            }
        } catch (e) {
            this.triggerList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    async searchDisplayNameList(userArr) {
        if (!userArr.length) {
            return;
        }
        const unionArr = Array.from(new Set(userArr));
        const res = await api.ctiApi.searchDisplayNameList(unionArr);
        const { code, data } = res;
        if (code === 200) {
            this.createDisplayNames = data;
        }
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.$router
            .push({
                name: 'rg_trigger',
                query: {
                    rgId: `${this.rgId}`,
                    cn: `${current}`
                }
            })
            .catch(e => e);
        this.getTriggerList();
    }
    // 启用触发器
    async triggerActiveSwitch(row: any) {
        try {
            const res = await api.ruleApi.triggerSwitch(row.id, row.active);
            const { code } = res;
            if (code === 200) {
                this.$mtd.message({
                    message: row.active ? '触发器开启成功' : '触发器关闭成功',
                    type: 'success'
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
    // 复制触发器
    async handleCopyTrigger(triggerId: number) {
        try {
            const res = await api.ruleApi.copyTrigger(triggerId);
            const { code } = res;
            if (code === 200) {
                this.$mtd.message.success('触发器复制成功');
                this.getTriggerList();
            }
        } catch (e) {
            console.log(e);
        }
    }
    // 触发器排序
    async triggerSortAction(param: CommonTypes.triggerSort) {
        const res = await api.ruleApi.triggerSort(param);
        const { code } = res;
        if (code === 200) {
            this.$mtd.message.success('操作成功');
            this.getTriggerList();
        }
    }
    // 添加触发器
    handleAddTrigger() {
        this.$router.push({
            name: 'trigger-edit',
            query: {
                rgId: `${this.rgId}`
            }
        });
    }
    // 编辑触发器
    handleEditTrigger(id: number) {
        this.$router
            .push({
                name: 'trigger-edit',
                query: {
                    id: `${id}`,
                    rgId: `${this.rgId}`,
                    cn: `${this.currentPage}`
                }
            })
            .catch(e => e);
    }
    // 删除触发器
    handleDeleteTrigger(row) {
        if (row.active) {
            this.unableDelete();
            return;
        }
        this.$mtd
            .confirm({
                title: '你是否确认删除该触发器？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '删除',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    try {
                        await api.ruleApi.deleteTrigger(row.id);
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await this.getTriggerList();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }
    // 不允许删除模板提示
    unableDelete() {
        this.$mtd
            .confirm({
                title: '请先停用触发器，再尝试删除',
                type: 'warning',
                width: '433px',
                okButtonText: '知道了'
            })
            .catch(e => e);
    }
    rowClass(scope) {
        const row = scope.row;
        if (!row.valid) {
            return 'highlight-row';
        }
        return '';
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
